import { Component, ViewChild } from "@angular/core";
import { FuneralCoverDesktopBenefitsDrawerComponent } from "./funeral-cover-desktop-benefits-drawer/funeral-cover-desktop-benefits-drawer.component";
import { FuneralCoverMobileBenefitsDrawerComponent } from "./funeral-cover-mobile-benefits-drawer/funeral-cover-mobile-benefits-drawer.component";
import { FuneralCoverDesktopPremiumDrawerComponent } from "./funeral-cover-desktop-premium-drawer/funeral-cover-desktop-premium-drawer.component";
import { FuneralCoverMobilePremiumDrawerComponent } from "./funeral-cover-mobile-premium-drawer/funeral-cover-mobile-premium-drawer.component";

import { InsuranceHubBaseComponent } from "../Insurance-hub-callback";
import { RouterModule } from "@angular/router";
@Component({
  selector: "app-funeral-cover",
  templateUrl: "./funeral-cover.component.html",
  styleUrls: ["./funeral-cover.component.css"],
  standalone: true,
  imports: [
    FuneralCoverDesktopBenefitsDrawerComponent,
    FuneralCoverMobileBenefitsDrawerComponent,
    FuneralCoverDesktopPremiumDrawerComponent,
    FuneralCoverMobilePremiumDrawerComponent,
    RouterModule
  ],
})
export class FuneralCoverComponent extends InsuranceHubBaseComponent {
  @ViewChild("funeralCoverDesktopBenefitsDrawer")
  funeralCoverDesktopBenefitsDrawer!: FuneralCoverDesktopBenefitsDrawerComponent;
  @ViewChild("funeralCoverMobileBenefitsDrawer")
  funeralCoverMobileBenefitsDrawer!: FuneralCoverMobileBenefitsDrawerComponent;
  @ViewChild("funeralCoverDesktopPremiumDrawer")
  funeralCoverDesktopPremiumDrawer!: FuneralCoverDesktopPremiumDrawerComponent;
  @ViewChild("funeralCoverMobilePremiumDrawer")
  funeralCoverMobilePremiumDrawer!: FuneralCoverMobilePremiumDrawerComponent;

  private offcanvasInstances: { [key: string]: any } = {};

  drawerContent;
  ngOnInit(): void {
    this.GetPolicyDetailData();
  }

  GetPolicyDetailData() {
    let uPolicyData = sessionStorage.getItem("UserPolicyDetails")
      ? JSON.parse(sessionStorage.getItem("UserPolicyDetails"))
      : null;
    if (uPolicyData?.funeralCoverPolicyResponse) {
      this.PolicyDetailResponse = uPolicyData.funeralCoverPolicyResponse;
    }
  }
  openFuneralCoverDesktopBenefitsDrawer() {
    this.funeralCoverDesktopBenefitsDrawer.openDrawer(
      this.PolicyDetailResponse
    );
  }

  openFuneralCoverMobileBenefitsDrawer() {
    this.funeralCoverMobileBenefitsDrawer.openDrawer(this.PolicyDetailResponse);
  }

  openFuneralCoverDesktopPremiumDrawer() {
    this.funeralCoverDesktopPremiumDrawer.openDrawer(this.PolicyDetailResponse);
  }

  openFuneralCoverMobilePremiumDrawer() {
    this.funeralCoverMobilePremiumDrawer.openDrawer(this.PolicyDetailResponse);
  }
}
